import { Api } from 'api';
import { callApi, callApiWithoutToken } from 'root/appSaga';
import { takeEvery, put, all } from 'redux-saga/effects';
import { userSlice } from 'features/user/userSlice';
import { User } from 'types';


export function* userSaga() {
    return yield all([
        takeEvery(userSlice.actions.createUser, createUser),
        takeEvery(userSlice.actions.getUser, getUser),
        takeEvery(userSlice.actions.saveUser, saveUser)
    ]);
}

export function* createUser(params: ReturnType<typeof userSlice.actions.createUser>) {
    try {
        const { user } = params.payload;
        yield callApiWithoutToken(Api.createUser, user);
        yield put(userSlice.actions.createUserCompleted({ user }));
    } catch (error) {
        yield put(userSlice.actions.createUserError({ error }));
    }
}

export function* getUser() {
    try {
        const user: User = yield callApi(Api.getUser);
        yield put(userSlice.actions.getUserCompleted({ user }));
    } catch (error) {
        yield put(userSlice.actions.getUserError({ error }));
    }
}

export function* saveUser(params: ReturnType<typeof userSlice.actions.saveUser>) {
    try {
        const { user } = params.payload;
        yield callApi(Api.saveUser, user);
        yield put(userSlice.actions.saveUserCompleted({ user }));
    } catch (error) {
        yield put(userSlice.actions.saveUserError({ error }));
    }
}
